<template>
    <v-popover offset="16" @show="generateQR">
        <i class="tlm-icon-check-circle text-success" />

        <template v-slot:popover>
            <table>
                <tbody>
                    <tr title="Регистрационный номер контрольно-кассовой техники, присваивается ФНС при регистрации.">
                        <td>ККТ</td>
                        <td>{{ value.device_rn }}</td>
                    </tr>

                    <tr title="Порядковый номер фискального документа.">
                        <td>ФД</td>
                        <td>{{ value.document_number }}</td>
                    </tr>

                    <tr title="Фискальный признак документа.">
                        <td>ФПД</td>
                        <td>{{ value.fp }}</td>
                    </tr>
                </tbody>
            </table>

            <img v-if="qr" :src="qr" class="mt-3">
        </template>
    </v-popover>
</template>

<script>
import QRCode from 'qrcode'
import { VPopover } from 'v-tooltip'

export default {
    components: {
        VPopover
    },

    props: {
        value: {
            type: Object,
            default: _ => ({})
        }
    },

    data() {
        return {
            qr: null
        }
    },

    computed: {
        qrText() {
            if (!this.value.date) {
                return null
            }

            return `t=${this.value.date}&s=${this.value.total_payment_amount}&fn=${this.value.fs_number}&i=${this.value.document_number}&fp=${this.value.fp}&n=${this.value.document_type}`
        }
    },

    methods: {
        async generateQR() {
            if (!this.qrText) {
                return
            }

            try {
                this.qr = await QRCode.toDataURL(this.qrText)
            } catch (error) {

            }
        }
    }
}
</script>

<style lang="scss" scoped>
i {
    cursor: pointer;
}

table {
    width: 100%;

    tr {
        td:first-child {
            text-align: left;
            font-weight: bold;
        }

        td:last-child {
            text-align: right;
        }
    }
}
</style>
